module.exports = __webpack_public_path__ + "img/TheosLogo.923ecf41.png";